var map = {
	"./charts/charts.module": [
		"./src/app/pages/charts/charts.module.ts",
		"app-pages-pages-module~charts-charts-module",
		"common",
		"charts-charts-module"
	],
	"./components/components.module": [
		"./src/app/pages/components/components.module.ts",
		"common",
		"components-components-module"
	],
	"./editors/editors.module": [
		"./src/app/pages/editors/editors.module.ts",
		"editors-editors-module"
	],
	"./forms/forms.module": [
		"./src/app/pages/forms/forms.module.ts",
		"forms-forms-module"
	],
	"./maps/maps.module": [
		"./src/app/pages/maps/maps.module.ts",
		"app-pages-pages-module~maps-maps-module",
		"common",
		"maps-maps-module"
	],
	"./miscellaneous/miscellaneous.module": [
		"./src/app/pages/miscellaneous/miscellaneous.module.ts",
		"common"
	],
	"./tables/tables.module": [
		"./src/app/pages/tables/tables.module.ts",
		"app-pages-pages-module~tables-tables-module",
		"common",
		"tables-tables-module"
	],
	"./ui-features/ui-features.module": [
		"./src/app/pages/ui-features/ui-features.module.ts",
		"ui-features-ui-features-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"app-pages-pages-module~charts-charts-module",
		"app-pages-pages-module~tables-tables-module",
		"app-pages-pages-module~maps-maps-module",
		"common",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;